export default function ArabicCourseLevels({ course, title }) {
  const courseLevels = {
    academic_ar: {
      level1: {
        "মূল বই": "১ম খন্ডের ২টি বই",
        "মোট পৃষ্ঠা": "প্রায় ৫৬৬ পৃষ্ঠা",
        "কোর্সের মেয়াদ": "৫ মাস",
        "লাইভ ক্লাসের ব্যপ্তি": "১ ঘন্টা ৩০ মিনিট",
        "ক্লাস টেস্ট": "MCQ",
        "সাপ্তাহিক পরীক্ষা": "MCQ",
        "মাসিক পরীক্ষা": "লিখিত",
        ফী: "মাসে ৳ ২০০০",
      },

      level2: {
        "মূল বই": "২য় খন্ডের ২টি বই",
        "মোট পৃষ্ঠা": "প্রায় ৫১৮ পৃষ্ঠা",
        "কোর্সের মেয়াদ": "৫ মাস",
        "লাইভ ক্লাসের ব্যপ্তি": "১ ঘন্টা ৩০ মিনিট",
        "ক্লাস টেস্ট": "MCQ",
        "সাপ্তাহিক পরীক্ষা": "MCQ",
        "মাসিক পরীক্ষা": "লিখিত",
        ফী: "মাসে ৳ ২০০০",
      },
      level3: {
        "মূল বই": "৩য় খন্ডের ২টি বই",
        "মোট পৃষ্ঠা": "প্রায় ৪৬৪ পৃষ্ঠা",
        "কোর্সের মেয়াদ": "৫ মাস",
        "লাইভ ক্লাসের ব্যপ্তি": "১ ঘন্টা ৩০ মিনিট",
        "ক্লাস টেস্ট": "MCQ",
        "সাপ্তাহিক পরীক্ষা": "MCQ",
        "মাসিক পরীক্ষা": "লিখিত",
        ফী: "মাসে ৳ ২০০০",
      },
      level4: {
        "মূল বই": "৪র্থ খন্ডের ২টি বই",
        "মোট পৃষ্ঠা": "প্রায় ৫১৬ পৃষ্ঠা",
        "কোর্সের মেয়াদ": "৫ মাস",
        "লাইভ ক্লাসের ব্যপ্তি": "১ ঘন্টা ৩০ মিনিট",
        "ক্লাস টেস্ট": "MCQ",
        "সাপ্তাহিক পরীক্ষা": "MCQ",
        "মাসিক পরীক্ষা": "লিখিত",
        ফী: "মাসে ৳ ২০০০",
      },
    },
    madina_ar: {
      level1: {
        "মূল বই": "১ম খন্ড",
        "মোট পৃষ্ঠা": "প্রায় ১২৬ পৃষ্ঠা",
        "কোর্সের মেয়াদ": "৫ মাস",
        "লাইভ ক্লাসের ব্যপ্তি": "১ ঘন্টা ১৫ মিনিট",
        "ক্লাস টেস্ট": "MCQ",
        "সাপ্তাহিক পরীক্ষা": "MCQ",
        "মাসিক পরীক্ষা": "লিখিত",
        ফী: "মাসে ৳ ১০০০",
      },

      level2: {
        "মূল বই": "২য় খন্ড",
        "মোট পৃষ্ঠা": "প্রায় ২২৩ পৃষ্ঠা",
        "কোর্সের মেয়াদ": "৫ মাস",
        "লাইভ ক্লাসের ব্যপ্তি": "১ ঘন্টা ১৫ মিনিট",
        "ক্লাস টেস্ট": "MCQ",
        "সাপ্তাহিক পরীক্ষা": "MCQ",
        "মাসিক পরীক্ষা": "লিখিত",
        ফী: "মাসে ৳ ১০০০",
      },
      level3: {
        "মূল বই": "৩য় খন্ড",
        "মোট পৃষ্ঠা": "প্রায় ৩২০ পৃষ্ঠা",
        "কোর্সের মেয়াদ": "৫ মাস",
        "লাইভ ক্লাসের ব্যপ্তি": "১ ঘন্টা ১৫ মিনিট",
        "ক্লাস টেস্ট": "MCQ",
        "সাপ্তাহিক পরীক্ষা": "MCQ",
        "মাসিক পরীক্ষা": "লিখিত",
        ফী: "মাসে ৳ ১০০০",
      },
    },
    grammar_ar: {
      level1: {
        "মূল বই": "মীযান ও মুনশাইব",
        "মোট পৃষ্ঠা": "প্রায় ১২৪ পৃষ্ঠা",
        "কোর্সের মেয়াদ": "৫ মাস",
        "লাইভ ক্লাসের ব্যপ্তি": "১ ঘন্টা",
        "ক্লাস টেস্ট": "MCQ",
        "সাপ্তাহিক পরীক্ষা": "MCQ",
        "মাসিক পরীক্ষা": "লিখিত",
        ফী: "মাসে ৳ ১৫০০",
      },

      level2: {
        "মূল বই": "নাহুমীর",
        "মোট পৃষ্ঠা": "প্রায় ১৩০ পৃষ্ঠা",
        "কোর্সের মেয়াদ": "৫ মাস",
        "লাইভ ক্লাসের ব্যপ্তি": "১ ঘন্টা",
        "ক্লাস টেস্ট": "MCQ",
        "সাপ্তাহিক পরীক্ষা": "MCQ",
        "মাসিক পরীক্ষা": "লিখিত",
        ফী: "মাসে ৳ ১৫০০",
      },
      level3: {
        "মূল বই": "ইলমুস সীগাহ",
        "মোট পৃষ্ঠা": "প্রায় ১৪০ পৃষ্ঠা",
        "কোর্সের মেয়াদ": "৫ মাস",
        "লাইভ ক্লাসের ব্যপ্তি": "১ ঘন্টা",
        "ক্লাস টেস্ট": "MCQ",
        "সাপ্তাহিক পরীক্ষা": "MCQ",
        "মাসিক পরীক্ষা": "লিখিত",
        ফী: "মাসে ৳ ১৫০০",
      },
      level4: {
        "মূল বই": "হেদায়াতুন নাহু",
        "মোট পৃষ্ঠা": "প্রায় ১২৮ পৃষ্ঠা",
        "কোর্সের মেয়াদ": "১০ মাস",
        "লাইভ ক্লাসের ব্যপ্তি": "১ ঘন্টা",
        "ক্লাস টেস্ট": "MCQ",
        "সাপ্তাহিক পরীক্ষা": "MCQ",
        "মাসিক পরীক্ষা": "লিখিত",
        ফী: "মাসে ৳ ১৫০০",
      },
    },
  };
  if (!course || !courseLevels[course]) {
    return null;
  }
  const levels = Object.keys(courseLevels[course]);
  const rowTitles = Object.keys(courseLevels[course][levels[0]]);

  return (
    <div>
      {course === "academic_ar" && (
        <section>
          <div className="overflow-x-auto ">
            <table className="table   mx-auto text-xl ">
              <thead>
                <tr>
                  <th className="text-xl">{title}</th>
                  <th className="text-xl">লেভেল ১</th>
                  <th className="text-xl">লেভেল ২</th>
                  <th className="text-xl">লেভেল ৩</th>
                  <th className="text-xl">লেভেল ৪</th>
                </tr>
              </thead>
              <tbody>
                {rowTitles.map((rowTitle) => (
                  <tr key={rowTitle}>
                    <td>{rowTitle}</td>
                    {levels.map((level) => (
                      <td key={level}>
                        {courseLevels[course]?.[level][rowTitle]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      )}
      {course === "madina_ar" && (
        <section>
          <div className="overflow-x-auto ">
            <table className="table   mx-auto text-xl ">
              <thead>
                <tr>
                  <th className="text-xl">{title}</th>
                  <th className="text-xl">লেভেল ১</th>
                  <th className="text-xl">লেভেল ২</th>
                  <th className="text-xl">লেভেল ৩</th>
                </tr>
              </thead>
              <tbody>
                {rowTitles.map((rowTitle) => (
                  <tr key={rowTitle}>
                    <td>{rowTitle}</td>
                    {levels.map((level) => (
                      <td key={level}>
                        {courseLevels[course]?.[level][rowTitle]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      )}

      {course === "grammar_ar" && (
        <section>
          <div className="overflow-x-auto ">
            <table className="table   mx-auto text-xl ">
              <thead>
                <tr>
                  <th className="text-xl">{title}</th>
                  <th className="text-xl">লেভেল ১</th>
                  <th className="text-xl">লেভেল ২</th>
                  <th className="text-xl">লেভেল ৩</th>
                  <th className="text-xl">লেভেল ৪</th>
                </tr>
              </thead>
              <tbody>
                {rowTitles.map((rowTitle) => (
                  <tr key={rowTitle}>
                    <td>{rowTitle}</td>
                    {levels.map((level) => (
                      <td key={level}>
                        {courseLevels[course]?.[level][rowTitle]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      )}
    </div>
  );
}
